import { PropsWithChildren } from 'react'
import { cn } from 'utils/style'

type EllipsisTextProps = PropsWithChildren<{
	textCenter?: boolean | undefined
}>

export const EllipsisText = ({ children, textCenter }: EllipsisTextProps) => {
	return (
		<div className={cn('table w-full table-fixed', textCenter ? 'text-center' : 'text-left')}>
			<div className="table-cell overflow-hidden text-ellipsis whitespace-nowrap break-all">
				{children}
			</div>
		</div>
	)
}
